<script lang="ts">
import services from "../../../composable/services";
import { computed } from "vue";
import "@/style/components/SummaryTableOfAuthorizationByData.scss";
import { PropType } from "vue";
import { LocalApplicationResult } from "@/types/front/LocalApplicationResult";
import { getLocalizedColumnName } from "@/composable/authorization/grantableInfos";

export default {
  name: "SummaryTableOfAuthorizationByData",
  props: {
    authorization: {
      type: Object,
      required: true,
    },
    application: {
      type: Object as PropType<LocalApplicationResult>,
      required: true,
    },
    listColumnName: {
      type: Object,
      required: true,
    },
  },
  emits: ["show-more"],
  setup(props) {
    let authorizationName = computed(() => {
      return props.authorization?.name || "";
    });
    let authorizationDescription = computed(() => {
      return props.authorization?.description || "";
    });
    let authorizationListAuthorizations = computed(() => {
      return props.authorization?.authorizations || [];
    });
    let authorizationId = computed(() => {
      return props.authorization?.uuid || [];
    });

    // Résout le label localisé d'une opération ( delete / depot /
    // extraction / publication ) à partir de l'autorisation courante .
    // Fallback : valeur brute du operationType si la colonne n'est pas
    // référencée dans `listColumnName.withoutScope` ( cas défensif ) .
    function localizedOperation(dataName: string, privilegeName: string): string {
      const opType = props.authorization?.[dataName]?.operationTypes?.[privilegeName];
      const column = props.listColumnName?.withoutScope?.[opType];
      return getLocalizedColumnName(column) || opType || "";
    }

    return {
      authorizationName,
      authorizationDescription,
      authorizationListAuthorizations,
      authorizationId,
      localizedOperation,
    };
  },
  computed: {
    services() {
      return services;
    },
  },
};
</script>

<template>
  <table class="column is-12 tableAuthByData">
    <thead class="rows">
      <tr>
        <th
          class="row"
          :aria-label="$t('dataTypeAuthorizations.name-data')"
        >
          {{ $t("dataTypeAuthorizations.name-data") }}
        </th>
        <th
          class="row"
          :aria-label="$t('dataTypeAuthorizations.privileges')"
        >
          {{ $t("dataTypeAuthorizations.privileges") }}
        </th>
      </tr>
    </thead>
    <tbody class="rows">
      <tr
        v-for="(dataName, index) in Object.keys(authorization)"
        :key="index"
      >
        <td
          class="row"
          :aria-label="services.internationalisationService.localeReferenceNames(dataName, application)"
        >
          {{ services.internationalisationService.localeReferenceNames(dataName, application) }}
        </td>
        <td
          v-if="application.configuration.dataDescription[dataName].authorization === null && listColumnName.withoutScope"
          class="row"
        >
          <p
            v-for="(configuration, privilegeName) in authorization[dataName].operationTypes"
            :key="privilegeName"
          >
            <span :aria-label="localizedOperation(dataName, privilegeName)">
              {{ localizedOperation(dataName, privilegeName) }}
            </span>
          </p>
        </td>
        <td
          v-else
          class="row"
        >
          <a
            :aria-label="$t('dataTypeAuthorizations.showMore')"
            @click="$emit('show-more')"
          >
            {{ $t("dataTypeAuthorizations.showMore") }}
          </a>
        </td>
      </tr>
    </tbody>
  </table>
</template>
